import { FormGroup } from '@angular/forms';
export class FormHelper {
  public static resetFormValidity(form: FormGroup): FormGroup {
    form.reset();

    Object.keys(form.controls).forEach(key => {
      form.controls[key].setErrors(null);
    });

    return form;
  }
}
